import { render, staticRenderFns } from "./connect-product-to-org-action.vue?vue&type=template&id=8c298212"
import script from "./connect-product-to-org-action.ts?vue&type=script&lang=ts&external"
export * from "./connect-product-to-org-action.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports